var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('banner-controls');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { BannerButton } from './banner-button';
import { Icons } from '../icons';
import { useFullscreen } from '../../hooks/use-fullscreen';
import { useReady } from '../../hooks/use-ready';
import { useSharePanel } from '../../hooks/use-share-panel';
import { useContributeForm } from '../../hooks/use-contribute-form';
import { withOwnProvider } from '../../utils/with-own-provider';
export var BANNER_CONTROLS_WIDTH_BASE = 44;
export var BANNER_CONTROLS_WIDTH = 50;
export var BannerControlsDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-self: stretch;\n    background: #969696;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    width: ", "px;\n  "], ["\n    align-self: stretch;\n    background: #969696;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    width: ", "px;\n  "])), BANNER_CONTROLS_WIDTH_BASE),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", "px;\n  "], ["\n    width: ", "px;\n  "])), BANNER_CONTROLS_WIDTH),
  desktopFullHD: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isFullscreen = _a.isFullscreen;
    return isFullscreen && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  })
});
var ItemStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    list-style: none;\n    margin: 0;\n    width: 100%;\n    height: 50%;\n    position: relative;\n    border-bottom: 1px solid ", ";\n    \n    ", "\n  "], ["\n    list-style: none;\n    margin: 0;\n    width: 100%;\n    height: 50%;\n    position: relative;\n    border-bottom: 1px solid ", ";\n    \n    ", "\n  "])), theme.COLOR('light'), function (_a) {
    var hasFeatureButton = _a.hasFeatureButton;
    return hasFeatureButton && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      height: 33.3333%;\n    "], ["\n      height: 33.3333%;\n    "])));
  }),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    height: 100%;\n\n    ", "\n  "], ["\n    height: 100%;\n\n    ", "\n  "])), function (_a) {
    var hasFeatureButton = _a.hasFeatureButton;
    return hasFeatureButton && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      height: 33.3333%;\n    "], ["\n      height: 33.3333%;\n    "])));
  })
});
var FeatureItemStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ItemStyles),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    border-bottom: none;\n    height: 66.6667%;\n  "], ["\n    border-bottom: none;\n    height: 66.6667%;\n  "])))
});
var ShareItemStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ItemStyles),
  desktop: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var hasFeatureButton = _a.hasFeatureButton;
    return !hasFeatureButton && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      border-bottom: none;\n    "], ["\n      border-bottom: none;\n    "])));
  })
});
var ShareButtonStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContributeButtonStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContributeItemStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", ";\n    ", "\n  "], ["\n    ", ";\n    ", "\n  "])), ItemStyles, function (_a) {
    var hasFeatureButton = _a.hasFeatureButton;
    return !hasFeatureButton && css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      border-bottom: none;\n    "], ["\n      border-bottom: none;\n    "])));
  }),
  desktop: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.ul(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ShareItem: styled.li.attrs(cls.attr('share-item'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ShareItemStyles),
  ShareButton: styled(BannerButton)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ShareButtonStyles),
  ContributeItem: styled.li.attrs(cls.attr('contribute-item'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContributeItemStyles),
  ContributeButton: styled(BannerButton)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContributeButtonStyles),
  FeatureItem: styled.li.attrs(cls.attr('feature-item'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), FeatureItemStyles)
};
export var BannerControlsComponent = function BannerControlsComponent(props) {
  var className = props.className,
      featureButton = props.featureButton;
  var contributeForm = useContributeForm();
  var sharePanel = useSharePanel();
  var fullscreen = useFullscreen();
  var hasFeatureButton = !!featureButton;
  var isReady = useReady().isReady;
  return React.createElement(My.Container, {
    isFullscreen: fullscreen.isActive,
    className: cls.name(className)
  }, isReady && React.createElement(React.Fragment, null, React.createElement(My.ShareItem, {
    hasFeatureButton: hasFeatureButton
  }, React.createElement(My.ShareButton, {
    title: "Share",
    onClick: sharePanel.toggleOnClick,
    iconColor: "light",
    icon: React.createElement(Icons.ShareCircle, null)
  })), hasFeatureButton && React.createElement(My.FeatureItem, null, featureButton), React.createElement(My.ContributeItem, {
    hasFeatureButton: hasFeatureButton
  }, React.createElement(My.ContributeButton, {
    title: "Give feedback",
    onClick: contributeForm.showOnClick,
    iconColor: "light",
    icon: React.createElement(Icons.ChatBubble, null)
  }))));
};
export var BannerControls = withOwnProvider(BannerControlsComponent);
BannerControls.defaultProps = BannerControlsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;